export default "__VITE_ASSET__o4$mx80z__"